import clsx from "clsx";

import IconCircleCheck from "@/app/_ui/central-icons/icons/IconCircleCheck";
import { iconStrokeFix } from "@/app/_ui/central-icons/iconUtils";

export const InlineSuccessScreen = ({
  heading,
  submitAnotherLabel,
  onReset,
  children,
}: {
  heading: string;
  submitAnotherLabel: string;
  onReset: () => void;
  children: React.ReactNode;
}) => {
  return (
    <div className='tw-py-12 tw-max-w-md tw-mx-auto tw-mt-12'>
      <h3 className='tw-type-2xl tw-mb-6'>{heading}</h3>
      {children}
      <div className='tw-text-center tw-mt-8'>
        <button
          className='tw-type-sm tw-text-gray-500 tw-underline tw-outline-none focus-visible:tw-outline-focus'
          onClick={onReset}
          type='button'
        >
          {submitAnotherLabel}
        </button>
      </div>
    </div>
  );
};

export const SuccessStep = ({ children }: { children: React.ReactNode }) => {
  return (
    <li className='tw-flex tw-items-start tw-gap-2'>
      <IconCircleCheck className={clsx(iconStrokeFix, "tw-shrink-0 tw-mt-0.5")} width={18} height={18} />
      <span>{children}</span>
    </li>
  );
};

export const SuccessStepList = ({ children }: { children: React.ReactNode }) => {
  return <ul className='tw-type-sm tw-text-gray-500 tw-space-y-3'>{children}</ul>;
};
